import React from "react";
import $ from "$";
import { Select, Icon, Button } from "antd";
import isEmpty from "lodash/isEmpty";
import random from "lodash/random";
import debounce from "lodash/debounce";
import isString from "lodash/isString";
import isFunction from "lodash/isFunction";
import uniq from "lodash/uniq";

import WeaLocaleProvider from "../../wea-locale-provider";
import WindowFunc from "../../wea-tools/window";

const { Option } = Select;
const { getLabel, formatMultiLang } = WeaLocaleProvider;

function stopPropagation(e) {
  e.stopPropagation && e.stopPropagation();
  e.preventDefault && e.preventDefault();
  e.nativeEvent && e.nativeEvent.preventDefault();
}

export function handleBlur() {
  const { onBlur } = this.props;
  this.setState({ searchList: [], activeKey: "" });
  isFunction(onBlur) && onBlur();
}

export function handleFocus() {
  const { onFocus } = this.props;
  this.setState({ focus: true, searchList: [], activeKey: "" });
  isFunction(onFocus) && onFocus();
}

export function handleClick(e) {
  const { clickCallback, isSingle, data } = this.props;
  if (this.hasAll()) {
    return;
  }
  isFunction(clickCallback) && clickCallback(data);
  stopPropagation(e);
}

export function onChange(data) {
  const { onChange } = this.props;
  isFunction(onChange) && onChange(data);
}

// 单选和 失去焦点仅展示 走 选中删除
export function handleSelect(id) {
  const { isSingle } = this.props;
  if (isSingle) {
    this.onChange(this.state.searchList.filter(item => item.id == id));
  }
}

export function handleDeselect(id, unfocus) {
  const { isSingle, data } = this.props;
  if (unfocus || isSingle) {
    this.onChange(data.filter(item => !(item.id == id)));
  }
}

// 多选 走数组 change
export function handleChange(selectIds) {
  const { isSingle, data } = this.props;
  if (!isSingle) {
    const list = data.concat(this.state.searchList);
    this.onChange(selectIds.map(id => list.filter(item => item.id == id)[0]));
  }
  if (this.hasAll() && selectIds.length === 0) {
    this.props.dropAllUserGroup && this.props.dropAllUserGroup();
  }
}

export function handleSearch(value) {
  const { onSearch, data, type } = this.props;
  if (data.some(d => d.type === "all") || type == "141") {
    return;
  }
  this.setState({ loading: true });
  this.getData(value);
  isFunction(onSearch) && onSearch(value);
}

export function selectedClickHandler(e, item) {
  const { isSingle, viewAtter, data } = this.props;
  if (viewAtter == 1) {
    item = item;
  } else {
    item = data.find(d => d.id == item.id && d.name == item.name) || item;
  }
  if (item) {
    if (this.isCrm()) {
      if (isSingle || (!isSingle && item.type === "resource")) {
        isFunction(window.openhrm) && window.openhrm(item.id);
        isFunction(window.pointerXY) && window.pointerXY(e.nativeEvent);
      } else if (!isSingle && item.type !== "resource" && item.type !== "all") {
        const target = $(e.nativeEvent.target);
        const parent = $(this.searchWrapper);
        const y = target.offset().top;
        const x = target.offset().left;
        const py = parent.offset().top;
        const px = parent.offset().left;
        const style = {
          top: y - py + 25,
          left: x - px
        };
        if (!isEmpty(item.users)) {
          this.setState({
            hrmlist: item.users,
            hrmlistVisible: true,
            hrmlistStyle: style
          });
        }
        stopPropagation(e);
      }
    } else {
      const { linkUrl, inputId, onLinkClick } = this.props;
      if (isFunction(onLinkClick)) {
        onLinkClick(e, item);
      } else if (linkUrl) {
        const url = `${linkUrl}${item[inputId] || item.id}`;
        window.open(url);
      }
    }
  }
}

export function getName(item) {
  if (!item) return "";
  const { isSingle, inputName } = this.props;
  let name = item.name || "";
  if (isSingle) {
    return name;
  } else if (this.isCrm()) {
    name = item.lastname || name;
    if (item.type) {
      if (item.type === "all") {
        return `${name}(${item.count})`;
      }
      if (item.type !== "resource") {
        return `${name}(${(item.users || []).length})`;
      }
    }
    return name;
  } else if (inputName) {
    // return item[`${inputName}span`] || item[inputName];
    return item[inputName];
  }
  if (isString(name)) {
    return formatMultiLang(name);
  }
  return name;
}

export function getPlaceholderElement() {
  const { props } = this;
  let hidden = false;
  if (props.data.length) {
    hidden = true;
  }
  const placeholder = props.placeholder;
  if (placeholder) {
    return (
      <div
        style={{ display: hidden ? "none" : "block" }}
        className={`ant-select-selection__placeholder`}
      >
        {placeholder}
      </div>
    );
  }
  return null;
}

export function focus() {
  this.select &&
    this.select.refs.rcSelect &&
    this.select.refs.rcSelect.onPlaceholderClick &&
    this.select.refs.rcSelect.onPlaceholderClick();
  if (!this.props.isSingle) {
    $(this.select)
      .find(".ant-select-search--inline")
      .css("minWidth", "10px");
    $(this.select)
      .find("input")
      .focus();
  }
}

export function selectMounted(select) {
  if (select) {
    this.select = select;
    if (this.state.focus) {
      this.focus();
    }
  }
}

export function countCrm() {
  const { data } = this.props;
  let count = 0;
  const ids = [];
  data.forEach(item => {
    if (item.type === "all") {
      count += item.count;
    } else if (item.type !== "resource") {
      item.users && item.users.forEach(u => ids.push(u.id));
    } else {
      ids.push(item.id);
    }
  });
  count += uniq(ids).length;
  return count;
}

// 处理所有人
export function hasAll() {
  const { isSingle, data } = this.props;
  return !isSingle && data.some(d => d.type === "all");
}

export function showCount() {
  let bool = false;
  const { data } = this.props;
  const resources = [];
  const groups = [];
  data.forEach(item => {
    if (item.type !== "resource" && item.type !== "all") {
      groups.push(item);
    } else {
      resources.push(item);
    }
  });
  if (groups.length > 1) bool = true;
  if (groups.length === 1 && resources.length > 0) bool = true;
  return bool;
}

export function getSelect(readyOnly) {
  if (readyOnly) {
    const { isSingle, data, readOnlyCallback } = this.props;
    const arr = [];
    data.forEach(item => {
      const name = this.getName(item);
      const handleClick = e =>
        readOnlyCallback
          ? readOnlyCallback.bind(this, item, e)()
          : this.selectedClickHandler(e, item);
      const props = {
        className: "child-item wdb",
        onClick: handleClick
      };
      if (isString(name)) {
        if (isSingle) {
          props.title = name;
        }
        props.dangerouslySetInnerHTML = { __html: name };
        arr.push(<a {...props} />);
      } else {
        arr.push(<a {...props}>{item}</a>);
      }
    });
    if (!isSingle && this.isCrm() && this.showCount()) {
      arr.push(
        <span style={{ color: "#bfbfc0" }}>
          ({getLabel(385618, "共$s人").replace(/\$s/, this.countCrm())})
        </span>
      );
    }
    return arr;
  }
  const {
    isSingle,
    fieldName,
    hasScroll,
    tempTitle,
    placeholder,
    hideSelect,
    maxBrowerHeight,
    getPopupContainer,
    layout,
    valueWarp,
    value,
    hideOps,
    data
  } = this.props;
  const { dropdownWidth, activeKey, searchList, loading, focus } = this.state;
  let options = [];
  try {
    options = searchList
      .filter(item => item && item.id && !data.some(d => d.id == item.id))
      .map(item => {
        const name = this.getName(item);
        return (
          <Option
            value={item.id}
            key={random(1000000000)}
            tooltip={item.title || name}
          >
            <span dangerouslySetInnerHTML={{ __html: name }} />
          </Option>
        );
      });
    options = options.concat(
      data.map(item => {
        const name = this.getName(item);
        return (
          <Option
            value={item.id}
            key={random(1000000000)}
            tooltip={item.title || name}
          >
            <a
              onClick={e => this.selectedClickHandler(e, item)}
              dangerouslySetInnerHTML={{ __html: name }}
            />
          </Option>
        );
      })
    );
  } catch (e) {
    /* eslint no-console: 0 */
    console && console.warn("浏览按钮脏数据: ", e);
    options = [];
  }
  const disabled = this.hasAll();
  const searchBtnProps = {
    type: "ghost",
    icon: "search",
    onClick: this.handleClick
  };
  if (disabled) {
    searchBtnProps.disabled = true;
    searchBtnProps.onClick = () => {};
  }
  let select = null;
  const cls = valueWarp ? "value-warp" : "";
  if (!focus) {
    const arr = [];
    data.forEach(item => {
      const name = this.getName(item);
      let domA = null;
      if (isString(name)) {
        domA = [
          <a
            onClick={e => this.selectedClickHandler(e, item)}
            dangerouslySetInnerHTML={{ __html: name }}
          />
        ];
      } else {
        domA = [
          <a onClick={e => this.selectedClickHandler(e, item)}>{item}</a>
        ];
      }
      // if (!isSingle && this.isCrm() && this.showCount()) {
      //   domA.push(
      //     <span style={{ color: "#bfbfc0" }}>
      //       ({getLabel(385618, "共$s人").replace(/\$s/, this.countCrm())})
      //     </span>
      //   );
      // }
      arr.push(
        <li
          unselectable="unselectable"
          className="ant-select-selection__choice "
        >
          <div className="ant-select-selection__choice__content">
            {domA}
            <span
              className="ant-select-selection__choice__remove"
              onClick={() => this.handleDeselect(item.id, true)}
            />
          </div>
        </li>
      );
    });
    select = (
      <div
        className={`ant-select ant-select-enabled ant-select-open ${cls}`}
        onClick={() => this.setState({ focus: true })}
      >
        <div
          className="ant-select-selection ant-select-selection--multiple"
          style={{ maxHeight: maxBrowerHeight || 110, overflowY: "auto" }}
        >
          <span
            className="ant-select-selection__rendered"
            id=""
            name=""
            style={{ display: "block" }}
          >
            <ul>
              {arr}
              {this.getPlaceholderElement()}
              <li className="ant-select-search ant-select-search--inline">
                <div className="ant-select-search__field__wrap">
                  <input className="ant-select-search__field" />
                  <span className="ant-select-search__field__mirror" />
                </div>
              </li>
            </ul>
          </span>
        </div>
      </div>
    );
  } else {
    select = (
      <Select
        className={cls}
        // selectedClickCB={this.selectedClickHandler} // 无法使用select自带的click方法，返回的数据格式不对
        {...this.props}
        ref={this.selectMounted}
        fieldName={fieldName}
        hasScroll={hasScroll}
        onInputBlur={() => this.setState({ focus: false })}
        title={tempTitle}
        hideSelected={true}
        transitionName=""
        animation=""
        value={value}
        multiple={true}
        maxHeight={maxBrowerHeight}
        placeholder={placeholder}
        notFoundContent=""
        activeKey={activeKey}
        defaultActiveFirstOption={true}
        showArrow={false}
        filterOption={false}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        onSelect={this.handleSelect}
        onDeselect={this.handleDeselect}
        onChange={this.handleChange}
        onSearch={!hideSelect && debounce(this.handleSearch, 400).bind(this)}
        selectedClose={true}
        dropdownStyle={{ minWidth: dropdownWidth }}
        dropdownMenuStyle={{ maxHeight: 160 }}
        getPopupContainer={() =>
          (getPopupContainer && getPopupContainer()) ||
          layout ||
          WindowFunc.getTop().document.body
        }
      >
        {options}
      </Select>
    );
  }
  return [
    select,
    <Icon type="loading" style={{ display: loading ? "block" : "none" }} />,
    !hideOps && (
      <div className="ant-input-group-wrap">
        <Button {...searchBtnProps} />
      </div>
    )
  ].filter(Boolean);
}



// WEBPACK FOOTER //
// ./ecology9/wea-browser-test/associative/getSelect.js